"use client"

import * as React from "react"
import { format, addDays, startOfDay } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

export function DatePicker({ className, value, onSelect, disabled, placeholder = "Pick a date" }) {
  const today = startOfDay(new Date())
  const maxDate = addDays(today, 365)
  const [open, setOpen] = React.useState(false)

  const handleSelect = (selectedDate) => {
    onSelect?.(selectedDate)
    setOpen(false)
  }

  return (
    <div className={cn("grid gap-2", className)}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant={"outline"}
            className={cn(
              "w-full justify-start text-left font-normal",
              !value && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {value ? format(value, "LLL dd, y") : <span>{placeholder}</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            initialFocus
            mode="single"
            selected={value || undefined}
            onSelect={handleSelect}
            disabled={disabled || { before: today, after: maxDate }}
            fromDate={disabled?.before || today}
            toDate={disabled?.after || maxDate}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}
